/**
 * Good Atoms Avatar System — 28 SVG avatars loaded as URL imports.
 * Each avatar renders as an <img> with hover pop animation (pure CSS).
 */

// ─── SVG URL imports ─────────────────────────────────────────────────────────

import thiefUrl     from '../../assets/avatars/01_thief-02.svg'
import hackerUrl    from '../../assets/avatars/02_hacker-02.svg'
import ninjaUrl     from '../../assets/avatars/03_ninja-02.svg'
import chickUrl     from '../../assets/avatars/04_chick-02.svg'
import robotUrl     from '../../assets/avatars/05_robot-02.svg'
import frenchUrl    from '../../assets/avatars/06_french-02.svg'
import blondeUrl    from '../../assets/avatars/07_Blonde_Girl.svg'
import hijabUrl     from '../../assets/avatars/08_Hijab_Girl_1.svg'
import afroUrl      from '../../assets/avatars/09_Afro_Girl_02.svg'
import gingerUrl    from '../../assets/avatars/10_Ginger_Girl.svg'
import astronautUrl from '../../assets/avatars/11_Astronaut_Girl.svg'
import chefUrl      from '../../assets/avatars/12_Chef.svg'
import pirateUrl    from '../../assets/avatars/13_Pirate.svg'
import singerUrl    from '../../assets/avatars/14_Singer.svg'
import samuraiUrl   from '../../assets/avatars/15_Samurai.svg'
import navajoUrl    from '../../assets/avatars/16_Navajo.svg'
import scientistUrl from '../../assets/avatars/17_scienctist.svg'
import skierUrl     from '../../assets/avatars/18_skier.svg'
import pharaohUrl   from '../../assets/avatars/19_pharaoh.svg'
import wizardUrl    from '../../assets/avatars/20_wizard.svg'
import builderUrl   from '../../assets/avatars/21_bob_Builder.svg'
import alienUrl     from '../../assets/avatars/22_alien.svg'
import ghostUrl     from '../../assets/avatars/23_ghost.svg'
import nunUrl       from '../../assets/avatars/24_nun.svg'
import queenUrl     from '../../assets/avatars/25_queen.svg'
import policeUrl    from '../../assets/avatars/26_police.svg'
import firemanUrl   from '../../assets/avatars/27_fireman.svg'
import vampireUrl   from '../../assets/avatars/28_vampire.svg'

// ─── Types ────────────────────────────────────────────────────────────────────

import { isAvatarId, type AvatarId } from './avatarIds'

// ─── Avatar ID → URL map ─────────────────────────────────────────────────────

const AVATAR_URLS: Record<AvatarId, string> = {
  thief:     thiefUrl,
  hacker:    hackerUrl,
  ninja:     ninjaUrl,
  chick:     chickUrl,
  robot:     robotUrl,
  french:    frenchUrl,
  blonde:    blondeUrl,
  hijab:     hijabUrl,
  afro:      afroUrl,
  ginger:    gingerUrl,
  astronaut: astronautUrl,
  chef:      chefUrl,
  pirate:    pirateUrl,
  singer:    singerUrl,
  samurai:   samuraiUrl,
  navajo:    navajoUrl,
  scientist: scientistUrl,
  skier:     skierUrl,
  pharaoh:   pharaohUrl,
  wizard:    wizardUrl,
  builder:   builderUrl,
  alien:     alienUrl,
  ghost:     ghostUrl,
  nun:       nunUrl,
  queen:     queenUrl,
  police:    policeUrl,
  fireman:   firemanUrl,
  vampire:   vampireUrl,
}

// ─── Props ────────────────────────────────────────────────────────────────────

export interface AvatarProps {
  id: string
  size?: number
  className?: string
}

// ─── Component ────────────────────────────────────────────────────────────────

export function Avatar({ id, size = 80, className }: AvatarProps) {
  const avatarId = isAvatarId(id) ? id : 'ninja'
  const url = AVATAR_URLS[avatarId]

  return (
    <div
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
      }}
    >
      <img
        src={url}
        alt={avatarId}
        width={size}
        height={size}
        draggable={false}
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          transition: 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.12)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
        }}
      />
    </div>
  )
}
